import MainHeader from "../Components/MainHeader";
import { useState } from "react";
import './Profile.css'

const Profile = () => {
    const [Total, setTotal] = useState(0)
    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    /*     const userName = userData.name;
        const userRides = userData.rides;
    
        let userRideDistance = 0;
        let userElevation = 0;
        let userRideTime = 0;
    
        for (let i = 0; i < userRides.length; i++) {
            userRideDistance += parseInt(userRides[i].distance);
            userElevation += parseInt(userRides[i].total_elevation_gain);
            userRideTime += parseInt(userRides[i].moving_time);
        } */

    const parentFunction = (x) => {
    };

    var hour = parseInt(userData.totalTime / 3600);
    var min = parseInt((userData.totalTime % 3600) / 60);
    var sec = userData.totalTime % 60;

    var create = new Date(userData.create_at)
    var update = new Date(userData.update_at)

    return (
        <div>
            <MainHeader parentFunction={parentFunction} />
            <div className="userTotalInfo">
                <div>
                    <img src={userData.profile} />
                </div>

                <h2>
                    {userData.name}
                </h2>
                <h4>
                    {userData.bio}
                </h4>
                <div>
                    {userData.city}, {userData.state}, {userData.country}
                </div>
                <div>
                    {create.toDateString()} ~ {update.toDateString()}
                </div>

                <div>
                <a>Total_ride_distance | {(userData.totalDistance/1000).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} Km</a>
                    </div>
                <div>
                    <a>Total_Elevation  | {userData.totalElevation.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} m</a>
                </div>
                <div>
                     <a>Total_ride_time     | {hour}시간 {min}분 {sec}초</a>
                </div>
                <div>
                     <a>Total_Kudos(총 획득 따봉수)     | {userData.totalKudos}개</a>
                </div>
            </div>
        </div>
    )
}

export default Profile